/**
 * Считывает bootstrap-данные из DOM-элемента mount-контейнера.
 * Возвращает null, если контейнер не найден или данные некорректны.
 */
export function readCategoryArticlesBootstrap() {
    var _a, _b, _c;
    const root = document.getElementById('category-articles-root');
    if (!root)
        return null;
    const categoryId = Number(root.dataset.categoryId);
    const initialPage = Number((_a = root.dataset.initialPage) !== null && _a !== void 0 ? _a : '1');
    const pageSize = Number((_b = root.dataset.pageSize) !== null && _b !== void 0 ? _b : '10');
    const apiEndpoint = (_c = root.dataset.apiEndpoint) !== null && _c !== void 0 ? _c : '';
    const categoryTitle = root.dataset.categoryTitle;
    if (!categoryId || !apiEndpoint)
        return null;
    return {
        categoryId,
        initialPage: Math.max(1, initialPage),
        pageSize: Math.max(1, pageSize),
        apiEndpoint,
        categoryTitle,
    };
}
